module.exports = __webpack_public_path__ + "img/J12092.22db53c6.png";